module.exports = __webpack_public_path__ + "img/Mickies_Pizzeria@2x.87b1de30.webp";